function NotFound() {
    return (
      <div>
        <h3>Error 404. Pagina no encontrada :(</h3>
      </div>
    );
  }
  
  export default NotFound;
  